import { window } from ".";
import { STRING_EMPTY } from "./string.js";
const HISTORY = window.history;
/**
 * @returns {unknown}
 */
export const HISTORY_GET_STATE = () => HISTORY.state;
/**
 * @param {any} data
 * @param {string | URL | null} [url]
 * @returns {void}
 */
export const HISTORY_PUSH_STATE = (data, url) => HISTORY.pushState(data, STRING_EMPTY, url);
/**
 * @param {any} data
 * @param {string | URL | null} [url]
 * @returns {void}
 */
export const HISTORY_REPLACE_STATE = (data, url) => HISTORY.replaceState(data, STRING_EMPTY, url);
